<template>
  <b-card class="shadow-sm">
    <b-card-body class="mb-4 px-6 pt-6">
      <!-- LOADING -->
      <div v-if="loading">
        <b-row class="text-center">
          <div class="col-6 border-right">
            <b-skeleton width="60%" height="18px" class="mx-auto mb-3" />
            <b-skeleton width="70%" height="48px" class="mx-auto" />
          </div>
          <div class="col-6">
            <b-skeleton width="60%" height="18px" class="mx-auto mb-3" />
            <b-skeleton width="70%" height="48px" class="mx-auto" />
          </div>
        </b-row>
      </div>

      <!-- CONTEÚDO -->
      <div v-else>
        <b-row class="text-center">
          <div
            class="col-6 border-right"
            style="cursor: pointer"
            @click="$router.push({ name: 'pessoasLista' })"
          >
            <b-card-title class="mb-5">
              <b-icon icon="people-fill" variant="primary" class="mr-2" />
              Pessoas
            </b-card-title>
            <h2 class="display-4 text-primary mb-0 font-weight-bold">
              {{ pessoas }}
            </h2>
          </div>

          <div
            class="col-6"
            style="cursor: pointer"
            @click="$router.push({ name: 'produtosLista' })"
          >
            <b-card-title class="mb-5">
              <b-icon icon="tags-fill" variant="primary" class="mr-2" />
              Produtos
            </b-card-title>
            <h2 class="display-4 text-primary mb-0 font-weight-bold">
              {{ produtos }}
            </h2>
          </div>
        </b-row>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "TotalizadorCadastros",
  props: {
    totaisCadastros: {
      type: Object,
      default: () => ({ produtos: 0, pessoas: 0 }),
    },
    loading: { type: Boolean, default: false },
    error: { type: String, default: null },
  },
  computed: {
    pessoas() {
      return Number(this.totaisCadastros?.pessoas ?? 0);
    },
    produtos() {
      return Number(this.totaisCadastros?.produtos ?? 0);
    },
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: rgba(0, 123, 255, 0.05); /* leve destaque */
  transition: background-color 0.2s ease;
}
</style>
